import {
    CHANGE_DATES,
    CHANGE_INTERVAL
} from './types/datepicker-action-types';
import {
    changeDomainType,
    selectDomain,
} from '../actions/domain-selector-action-creators';
import {
    handleInitialLoad
} from './domain-portfolio-dmarc-selector-action-creators';
import {
    dateOptionMap,
    intervalMap
} from '../../common/constants/date-options';
import { getQueryParams, updateQueryParam } from '../../utils/query-param-utils';
import {
    selectedDateOptionSelector,
    selectedIntervalSelector
} from '../../reports/selectors/reports-selectors';

import { evalDateOption } from '../../utils/datepicker-utils';

function shouldUpdateInterval( newDateSelection, currentDateOption, currentIntervalSelection ){
    const validIntervalOptions = intervalMap[newDateSelection];
    if( validIntervalOptions ){
        return !validIntervalOptions.includes( currentIntervalSelection ) || currentDateOption !== newDateSelection;
    }
    return false;
}

export function changeDates( dates ){
    return ( dispatch, getState ) => {
        const { namespace, option, start, end } = dates;
        const resultOption = evalDateOption( option );

        const state = getState();
        const currentInterval = selectedIntervalSelector( state );
        const currentDateOption = selectedDateOptionSelector( state );

        if( shouldUpdateInterval( resultOption, currentDateOption, currentInterval ) ){
            dispatch( changeInterval( {
                interval: intervalMap[resultOption][0],
                namespace: namespace,
            } ) );
        }

        updateQueryParam( { dateRange: resultOption } );
        return dispatch( {
            end,
            namespace,
            option: resultOption,
            start,
            type: CHANGE_DATES,
        } );
    };
}

export function changeInterval( params ){
    const { namespace, interval } = params;
    updateQueryParam( { interval } );
    return {
        interval,
        namespace,
        type: CHANGE_INTERVAL,
    };
}

export function handleReportsInitialLoad( isDomainPortfolio = false ){
    return ( dispatch, getState ) => {

        if( isDomainPortfolio ){
            return handleDomainPortfolioInitialLoad( dispatch, getState );
        }
        const { dateRange, interval, domain, domainType } = getQueryParams();
        if( dateRange && interval ){
            const { start, end } = dateOptionMap[dateRange];
            dispatch( changeDates( {
                end,
                namespace: 'reports',
                option: dateRange,
                start,
            } ) );
        }
        else{
            const state = getState();
            const interval = selectedIntervalSelector( state );
            const dateRange = selectedDateOptionSelector( state );
            updateQueryParam( { dateRange, interval } );
        }

        if( domain ){
            dispatch( selectDomain( {
                domain: domain,
                namespace: 'reports'
            } ) );
        }
        if( domainType ){
            dispatch( changeDomainType( {
                domainType,
                namespace: 'reports'
            } ) );
        }
    };
}

function handleDomainPortfolioInitialLoad( dispatch, getState ){
    const { dateRange, interval, domain, domainType } = getQueryParams();
    handleInitialLoad( dispatch, getState );
    if( dateRange ){
        const { start, end } = dateOptionMap[dateRange];
        dispatch( changeDates( {
            end,
            namespace: 'reports',
            option: dateRange,
            start,
        } ) );
    }
    else{
        const state = getState();
        const dateRange = selectedDateOptionSelector( state );
        updateQueryParam( { dateRange } );
    }

    if( domain ){
        updateQueryParam( { domain: undefined } );
    }
    if( domainType ){
        updateQueryParam( { domainType: undefined } );
    }
    if( interval ){
        updateQueryParam( { interval: undefined } );
    }
}
